/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetKeyTestDto } from './GetKeyTestDto';
import {
    GetKeyTestDtoFromJSON,
    GetKeyTestDtoFromJSONTyped,
    GetKeyTestDtoToJSON,
} from './GetKeyTestDto';

/**
 * 
 * @export
 * @interface GetKeyValueDto
 */
export interface GetKeyValueDto {
    /**
     * 
     * @type {string}
     * @memberof GetKeyValueDto
     */
    id: string;
    /**
     * 
     * @type {GetKeyTestDto}
     * @memberof GetKeyValueDto
     */
    keyTest?: GetKeyTestDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeyValueDto
     */
    taskNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeyValueDto
     */
    taskIdent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeyValueDto
     */
    answer?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetKeyValueDto
     */
    weight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetKeyValueDto
     */
    param1?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetKeyValueDto
     */
    param2?: number | null;
}

/**
 * Check if a given object implements the GetKeyValueDto interface.
 */
export function instanceOfGetKeyValueDto(value: object): value is GetKeyValueDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetKeyValueDtoFromJSON(json: any): GetKeyValueDto {
    return GetKeyValueDtoFromJSONTyped(json, false);
}

export function GetKeyValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKeyValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'keyTest': json['keyTest'] == null ? undefined : GetKeyTestDtoFromJSON(json['keyTest']),
        'taskNumber': json['taskNumber'] == null ? undefined : json['taskNumber'],
        'taskIdent': json['taskIdent'] == null ? undefined : json['taskIdent'],
        'answer': json['answer'] == null ? undefined : json['answer'],
        'weight': json['weight'] == null ? undefined : json['weight'],
        'param1': json['param1'] == null ? undefined : json['param1'],
        'param2': json['param2'] == null ? undefined : json['param2'],
    };
}

export function GetKeyValueDtoToJSON(value?: GetKeyValueDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'keyTest': GetKeyTestDtoToJSON(value['keyTest']),
        'taskNumber': value['taskNumber'],
        'taskIdent': value['taskIdent'],
        'answer': value['answer'],
        'weight': value['weight'],
        'param1': value['param1'],
        'param2': value['param2'],
    };
}

